import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

@observer
class WorkSharingListCompact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
        };
    }

    loadItems = async () => {
        const { workSharingItemStore, userStore } = this.props.stores;
        const { customer } = userStore;
        if (customer?.featureFlags?.workSharing) {
            await workSharingItemStore.getItems({ status: '' });
            this.setState({ loaded: true });
        }
    }

    openNewItem = (e) => {
        e.preventDefault();
        const { appState } = this.props.stores;
        const { drawerHeightMedium } = appState;
        appState.openDrawer('newWorkSharingItem', {
            height: drawerHeightMedium,
            callback: this.loadItems,
        }, 1);
    }

    openItem = (e, item) => {
        e.preventDefault();
        const { appState } = this.props.stores;
        const { drawerHeightMedium } = appState;
        appState.openDrawer('viewWorkSharingItem', {
            id: item.id,
            height: drawerHeightMedium,
            callback: this.loadItems,
        }, 1);
    }

    componentDidMount() {
        this.loadItems();
    }

    componentDidUpdate() {
        const { userStore } = this.props.stores;
        const { customer } = userStore;
        if (customer?.featureFlags?.workSharing && !this.state.loaded) {
            this.loadItems();
        }
    }

    render() {
        const { stores, classNames = '' } = this.props;
        const { userStore, workSharingItemStore } = stores;
        const { customer } = userStore;
        if (!customer?.featureFlags?.workSharing) {
            return null;
        }
        const workSharingItems = (workSharingItemStore.workSharingItems || []).filter(i => i.status === 'open' || i.status === 'in_progress');

        return (
            <div class={`px-2 pt-1 mb-3 ${classNames}`}>
                <div class='card mb-3 rounded-lg overflow-hidden'>
                    <div class='card-body pb-2'>
                        <div class='d-flex justify-content-between align-items-center mb-2'>
                            <h6 class='mb-0'>
                                <i class='fa-solid fa-share-nodes me-2' />
                                Arbeidsdeling ({workSharingItems.length})
                            </h6>
                            <div class='d-flex align-items-center gap-2'>
                                <a href='#' onClick={this.openNewItem} class='btn btn-sm btn-primary rounded-pill'>
                                    <i class='fa-solid fa-plus me-1' /> Ny jobb
                                </a>
                                <a href='/work-sharing/' class='small text-decoration-none'>Vis alle</a>
                            </div>
                        </div>
                        {workSharingItems.length === 0 && (
                            <p class='text-body-secondary mb-0' style='font-size: 0.9rem;'>Ingen aktive jobber</p>
                        )}
                    </div>
                    {workSharingItems.length > 0 && (
                        <div class='table-responsive'>
                            <table class='table table-sm table-hover mb-0' style='font-size: 0.85em;'>
                                <thead>
                                    <tr>
                                        <th class='py-1 border-0 text-body-secondary ps-3' style='font-weight: 500;'>Dyreeier</th>
                                        <th class='py-1 border-0 text-body-secondary' style='font-weight: 500;'>Adresse</th>
                                        <th class='py-1 border-0 text-body-secondary' style='font-weight: 500;'>Oppgave</th>
                                        <th class='py-1 border-0 text-body-secondary pe-3' style='font-weight: 500;'>Opprettet av</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {workSharingItems.map(item => {
                                        const visitorName = item.visitorData ? `${item.visitorData.firstname || ''} ${item.visitorData.lastname || ''}`.trim() : item.contactName || '-';
                                        const visitorAddress = item.visitorData
                                            ? [item.visitorData.address, item.visitorData.postalcode, item.visitorData.place].filter(Boolean).join(', ')
                                            : [item.locationAddress, item.locationPostalcode, item.locationPlace].filter(Boolean).join(', ') || '-';
                                        return (
                                            <tr key={item.id} style='cursor: pointer;' onClick={(e) => this.openItem(e, item)}>
                                                <td class='py-1 ps-3'>{visitorName}</td>
                                                <td class='py-1'>{visitorAddress}</td>
                                                <td class='py-1'>
                                                    <span class={`badge me-1 ${item.priority === 'urgent' ? 'bg-danger' : item.priority === 'high' ? 'bg-warning text-dark' : item.status === 'in_progress' ? 'bg-primary' : 'bg-secondary'}`} style='font-size: 0.75em;'>
                                                        {item.status === 'in_progress' ? 'Pågår' : item.priority === 'urgent' ? 'Haster' : item.priority === 'high' ? 'Høy' : ''}
                                                    </span>
                                                    {item.title}
                                                </td>
                                                <td class='py-1 pe-3 text-body-secondary'>{item.createdByName || '-'}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default WorkSharingListCompact;
